import {GetProcedureV3Request} from 'domain/usecases/private/guide-flow/medical-guide/get-procedure-v3';
import {makeGetProcedureMedicalGuideV3} from 'main/factories/usecases/private/guide-flow/remote-medical-guide/get-procedure-factory-v3';

export async function getHealthProcedureData(params: GetProcedureV3Request) {
	return await makeGetProcedureMedicalGuideV3().get(params);
}
